import type { SignInSkin } from "@serophin/browser";

/** The sign-in button, shared by every provider. */
export const AUTH_BUTTON =
  "w-full flex items-center justify-center gap-2 px-4 py-3 border border-neutral-300 dark:border-neutral-700 rounded-md text-sm font-medium transition-colors text-neutral-700 dark:text-neutral-200 bg-white dark:bg-neutral-800 hover:bg-neutral-50 dark:hover:bg-neutral-700 disabled:bg-neutral-100 dark:disabled:bg-neutral-800 disabled:text-neutral-400 dark:disabled:text-neutral-500 disabled:cursor-not-allowed";

export const AUTH_LINK = "text-blue-600 dark:text-blue-400 underline hover:no-underline";

export const AUTH_SKIN: SignInSkin = {
  label: "sr-only",
  input:
    "w-full px-3 py-2 border border-neutral-300 dark:border-neutral-600 rounded-md text-sm bg-white dark:bg-neutral-800 text-neutral-900 dark:text-neutral-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent",
  inputError: "border-red-500! focus:border-red-500! focus:ring-red-500!",
  primaryButton: AUTH_BUTTON,
  linkButton: "text-xs text-blue-600 dark:text-blue-400 underline hover:no-underline disabled:no-underline disabled:text-neutral-400",
  error: "text-sm text-red-600 dark:text-red-400",
  divider: "flex justify-center text-sm text-neutral-500 dark:text-neutral-400",
};
